import { User } from '@/models/user';
import { Typography } from 'antd';
import Modal from '../Modal';
import { FootprintList } from '../UserModal/FootprintList';
import { UserDeviceInfo } from './UserDeviceInfo';
import UserName from './Name';

export const showUserFootprintModal = async (record: User) => {
  Modal.info({
    icon: null,
    maskClosable: true,
    width: 500,
    title: (
      <>
        <UserName user={record} />
      </>
    ),
    content: (
      <>
        <UserDeviceInfo user={record} />
        <FootprintList user={record} header={<Typography.Title level={5}>Trace</Typography.Title>} />
      </>
    ),
  });
};
